PJQ.tours = {};
PJQ.views.tours = {};
PJQ.helpers.tours = {
    initTour: function () {
        if (!PJQ.app.session.get('onAccount') && !PJQ.app.session.user.get('tourDone') && PJQ.app.session.get('portalId') === PJQ.constants.panteraPortalId) {
            new PJQ.views.tours.SubscriptionTourIntro();
        }
    }
};

PJQ.tours.BaseTour = class {
    constructor(options = {}) {
        this.options = _.defaults(options, {
            onEnd: _.bind(function () {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'tour'
                        }
                    ])
                }).put().done(function () {
                }).fail(function () {
                });
            }, this),
            framework: 'bootstrap4',
            showIfUnintendedOrphan: true,
            showProgressText: false,
            showProgressBar: false,
            steps: [
                {
                    element: ".nav-myprojects",
                    content: "The Projects tab is where you can view, create, and manage all of your projects.  Let's take a look at a sample project to get you familiar with some of the tools.",
                    container: '#Body',
                    placement: 'auto',
                    onShow: _.bind(function() {
                        PJQ.app.router.navigate('myprojects', {
                            trigger: true
                        });
                    }, this),
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('projects')) {
                            if (0 > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projects')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/dashboard', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".project-dashboard",
                    orphan: true,
                    content: "This is your project dashboard.  It's the first thing you will see when you enter your project. Here you can get an overview for your project, see shared documents, and check the project news feed.",
                    placement: 'auto',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('projects')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projects')) {
                            PJQ.app.router.navigate('myprojects', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-project",
                    content: "Here you can navigate through all of your project tools.  Next we'll take a look at Project Details.",
                    placement: 'right',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('projects')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projects')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/dashboard', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projects')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/details', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-details",
                    content: "Project Details is where you can add, view, or modify information relating to the Project.  You can also add custom fields in the settings if there is other information you would like to be shown.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('projects')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projectMessaging')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/messaging', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-messaging",
                    content: "Messaging is where you will manage all of your Invitations to Bid.  It's extremely easy to invite people from your address book, or quickly send to a single email.  Once you have an existing project you can also invite from those projects.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('projectMessaging')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projects')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/details', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('privateMessaging')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/privatemessaging', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-privatemessaging",
                    content: "Anyone who has access to this project can easily message you which can also include attachments they wish for you to see.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('privateMessaging')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.tour.prev();
                            } else {
                                this.tour.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projectMessaging')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/messaging', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('bidForms')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/bidforms', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-bidforms",
                    content: "Send bid forms to project participants, or add a bid form to a specific trade.  You can also manage, and view any existing bid forms.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('bidForms')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('privateMessaging')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/privatemessaging', {
                                trigger: true
                            })
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projects')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/contacts', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-projectcontacts",
                    content: "Here is where you will manage any of your Project Contacts.  Project contacts will be anyone you will want to assign to handle tasks such as Daily Reports.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('projects')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('bidForms')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/bidforms', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('drawings')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/drawings', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-drawings",
                    content: "View and manage all of your drawings!  It's easy to upload, revise, and share all of your drawings.  When your drawings are uploaded, our system will automatically attempt to find the page number and name it accordingly for quick organization.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('drawings')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projects')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/contacts', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projectAttachments')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/attachments', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-attachments",
                    content: "Easily upload, organize, store, and share all of your documents.  All attachments uploaded through the project can be accessed here.  By default there will be a shared and private folder, but you can also add more folders as needed.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('projectAttachments')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('drawings')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/drawings', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('schedule')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/schedule', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-projectschedule",
                    content: "Scheduling is your most important tool for staying on top of your project. Add tasks with dependencies and successors and create a critical path.",
                    placement: 'bottom',
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projectAttachments')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/attachments', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('photoGallery')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/photos', {
                                trigger: true
                            });
                        }
                    }, this),
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('schedule')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                },
                {
                    element: ".nav-projectphotos",
                    content: "Your Photo Gallery contains any photos uploaded throughout your project.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('photoGallery')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('schedule')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/schedule', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('rfi')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/rfi', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-rfi",
                    content: "Send, receive, and collaborate on RFIs with other project contacts",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('rfi')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('photoGallery')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/photos', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('submittals')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/submittals', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-submittals",
                    content: "Create, collect, and manage your submittals for the project",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('submittals')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('rfi')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/rfi', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('dailyReports')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/dailyreports', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-dailyreports",
                    content: "Track daily, weekly, and monthly project tasks and details with your Daily Reports.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('dailyReports')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('submittals')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/submittals', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('punchList')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/punchlists', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-punchlists",
                    content: "Assign a punch list item to one of your project contacts. They’ll receive an immediate notification!",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('punchList')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('dailyReports')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/dailyreports', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projectReports')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/reports', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-projectreports",
                    content: "View and export reports related to the project.  Reports include a detailed participant list, project stats, and more!",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('projectReports')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('punchList')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/punchlists', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        PJQ.app.router.navigate('projectinvites', {
                            trigger: true
                        });
                    }, this)
                },
                {
                    element: ".nav-projectinvites",
                    content: "The Project Invites tab is where you can view all of your Invitations to Bid from other contractors.",
                    placement: 'bottom',
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('projectReports')) {
                            PJQ.app.router.navigate('projects/' + this.options.projectId + '/reports', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('contacts')) {
                            PJQ.app.router.navigate('contacts', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-contacts",
                    content: "Using the address book makes it easy to manage your contacts and add them to your projects.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('contacts')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        PJQ.app.router.navigate('projectinvites', {
                            trigger: true
                        });
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('documents')) {
                            PJQ.app.router.navigate('documents', {
                                trigger: true
                            });
                        }
                    }, this)
                },
                {
                    element: ".nav-documents",
                    content: "Quickly view documents from all of your projects.",
                    placement: 'bottom',
                    onShown: _.bind(function () {
                        if (!PJQ.app.session.subscription.hasFeature('documents')) {
                            if (this.previousStep > this.tour.getCurrentStepIndex()) {
                                this.prev();
                            } else {
                                this.next();
                            }
                        }
                    }, this),
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (PJQ.app.session.subscription.hasFeature('contacts')) {
                            PJQ.app.router.navigate('contacts', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        PJQ.app.router.navigate('profile', {
                            trigger: true
                        });
                    }, this)
                },
                {
                    element: ".nav-profile",
                    content: "Here’s where you can make sure all of your profile settings are correct. \n" +
                        "<br> <br> PRO TIP: Always check and make sure your Work Areas is up to date so you can receive the best leads!\n",
                    placement: 'bottom',
                    onPrev: _.bind(function () {
                        this.setStep();
                        if (!PJQ.app.session.subscription.hasFeature('documents')) {
                            PJQ.app.router.navigate('documents', {
                                trigger: true
                            });
                        }
                    }, this),
                    onNext: _.bind(function () {
                        this.setStep();
                        PJQ.app.router.navigate('prequal', {
                            trigger: true
                        });
                    }, this)
                },
                {
                    element: ".nav-prequal",
                    content: "Save even more time by filling out your PreQualification details here, so you can easily share them with a General Contractor.",
                    placement: 'bottom',
                    onPrev: _.bind(function () {
                        this.setStep();
                        PJQ.app.router.navigate('profile', {
                            trigger: true
                        });
                    }, this)
                },
                {
                    element: ".screening-dashboard-body",
                    content: "Congratulations! You've made it to the end our your Pantera Tools tour. When you're ready, click the \"End Tour\" button below to start getting more leads!",
                    placement: 'left'
                }
            ]

        });
        this.start();
    }

    start() {
        this.tour = new Tour(this.options);
        this.tour.start(true);
    }

    next() {
        this.tour.next();
    }

    prev() {
        this.tour.prev();
    }

    setStep() {
        this.previousStep = this.tour.getCurrentStepIndex();
    }
}

PJQ.views.tours.SubscriptionTourIntro = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-tour-intro'),
        maxWidth: 800,
        isVerticalCenter: true
    },
    events: {
        'click .btn-start-tour': 'startTour',
        'click .btn-skip-tour': 'skipTour'
    },
    startTour: function () {
        if (PJQ.app.session.user.get('tourDone')) {
            window.localStorage.clear();
        }
        let projectId = null,
            projects = new PJQ.collections.projects.Projects(null, {
                isSimple: false,
                status: 'ready',
                isMyProjects: true
            });
        projects.fetch({
            success: _.bind(function (data) {
                _.each(_.filter(data.models, function (model) {
                    return model.get('projectName') === 'Sample Project'
                }), function (model) {
                    projectId = model.get('projectId');
                })
                if (projectId != null) {
                    PJQ.app.tour = new PJQ.tours.BaseTour({
                        projectId: projectId
                    });
                }
                else if(data.models.length > 0){
                    projectId = data.models[0].get('projectId');
                    if(projectId != null){
                        PJQ.app.tour = new PJQ.tours.BaseTour({
                            projectId: projectId
                        });
                    }
                }
            }, this)
        })
        this.removeModal();
    },
    skipTour: function () {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'tour'
                }
            ])
        }).put().done(function () {
        }).fail(function () {
        });
    }
})
